import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import './App.css';
import Landing from "./components/Landing";
import Culture from "./components/Culture";
import Nav from './components/Nav.js';
import Community from "./components/Community";
import { mediaQueries } from "./shared/config";

import fb from './images/socials/fb.svg'
import insta from './images/socials/insta.svg'
import twitter from './images/socials/twitter.svg'
import tiktok from './images/socials/tiktok.svg'
import email from './images/socials/email.svg'

const Paragraph = styled.div`
font-family: Poppins;
font-style: normal;
font-weight: 400;
font-size: 18px;
line-height: 27px;
margin-left: 211px;
margin-right: 211px;
padding-top: 40px;
padding-bottom: 40px;
${mediaQueries.tablet} {
  margin-left: 30px;
  margin-right: 30px;
  padding-top: 20px;
  padding-bottom: 40px;
}
`

const Footer = styled.div`
  /* border: 1px solid black; */
	/* background-color: white; */
	min-height: 100px;
	color: black;
	padding: 80px 0 40px 0;
  /* padding-bottom: 20px; */
  text-align: center;
	h1 {
		margin: 0;
		font-family: 'Times New Roman', Times, serif;
	}
  ${mediaQueries.tablet} {

  padding-top: 0px;

}
`
const Socials = styled.div`
  position: relative;
	margin-top: 20px;
  
	img {
    position: relative;
		margin: 0 20px;
	}
	p {
    position: relative;
		margin-top: 80px;
    padding-bottom: 20px;
		${mediaQueries.mobile} {
			margin-top: 50px;
      
		}
	}
`

function App() {
  const [ data, setData ] = useState(null);
  
  useEffect(() => {
		fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/flatpage.2021.hhm")
		.then(res => res.json())
		.then(res => setData(res.data['article.aml']))
  }, [])

  return (
  
      <div className="App">
        <Landing/>
        <Nav/>
        <Paragraph> 
        The Grupo Folklórico dancers featured on this flatpage are wearing traditional dresses from different regions of Mexico.
        <br/>
        <br/>
        Editor’s note: Daily Bruin used Latino, Latina, Latinx and Hispanic in these articles according to sources’ preferences.
        </Paragraph>
        <Culture name="1"/>
        <Community name="2"/>
        <Footer>
          <h1>DAILY BRUIN</h1>
          <Socials>
					  <a href="https://www.instagram.com/dailybruin" target="_blank"><img src={insta}/></a>
					  <a href="https://www.facebook.com/dailybruin" target="_blank"><img src={fb}/></a>
					  <a href="https://www.twitter.com/dailybruin" target="_blank"><img src={twitter}/></a>
					  <a href="https://www.tiktok.com/@dailybruin" target="_blank"><img src={tiktok}/></a>
					  <a href="http://eepurl.com/cFEiZX" target="_blank"><img src={email}/></a>
					  <p>Built with Suzy’s ♥ in Kerckhoff 118 by Aritra Mullick and Sunny Li. Designed by Lauren Ho, Benny Zhang, Rachel Kwan and Maya O’Kelly.</p>
				  </Socials>
        </Footer>
      </div>
  );
}

export default App;
